// Program Type helpers (v2.0). Mirrors server/lib/programType.js.
export const PROGRAM_TYPES = [
  {
    value: 'paid',
    label: 'Paid',
    short: 'I collect a monthly fee from parents',
    detail: 'Track who has paid each month and show parents how to pay you.',
  },
  {
    value: 'free',
    label: 'Free',
    short: 'No fee — rec, church, or volunteer program',
    detail: 'No payment tracking anywhere. Rosters, schedule, and messages only.',
  },
  {
    value: 'free_ymca',
    label: 'Free — YMCA',
    short: 'No fee, run through a YMCA',
    detail: 'Same as Free, and your YMCA is shown to you and your parents.',
  },
];

export const isFreeProgram = (type) => type === 'free' || type === 'free_ymca';

export const programTypeLabel = (type) =>
  (PROGRAM_TYPES.find((t) => t.value === type) || PROGRAM_TYPES[0]).label;

// "Downtown YMCA" from a program row (directory pick or typed name).
export const ymcaNameOf = (program) =>
  program?.ymcas?.name || program?.ymca_other || null;

// "?type=free_ymca" on /coach/register (from the YMCA sub-page) preselects
// the picker. Anything else is ignored so a bad link cannot pick a type.
export const programTypeFromQuery = (value) =>
  (PROGRAM_TYPES.some((t) => t.value === value) ? value : '');
